<template>
  <div>
    <a href="/#feedback" class="message-btn">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_13_2)">
        <path d="M17.143 2.44497C15.88 3.36597 14.924 4.65997 14.11 5.84897L13.472 6.78697C13.2739 7.07653 13.1832 7.42625 13.2157 7.7756C13.2482 8.12494 13.4018 8.45193 13.65 8.69997L15.006 10.056L14.863 10.36C14.513 11.069 13.909 12.09 13 13C12.3723 13.6182 11.6647 14.1496 10.896 14.58L10.529 14.777L10.202 14.939L10.056 15.006L8.70098 13.65C8.45197 13.4013 8.12353 13.2479 7.77299 13.2167C7.42245 13.1854 7.07207 13.2783 6.78299 13.479L5.76898 14.182C4.61698 14.992 3.41398 15.915 2.47898 17.113C2.31736 17.3209 2.21455 17.5684 2.1813 17.8296C2.14805 18.0908 2.18559 18.3562 2.28999 18.598C3.12699 20.551 5.24498 22.214 7.44798 22.132L7.74798 22.116L7.98099 22.096L8.23899 22.066L8.51999 22.028L8.82498 21.977L9.15098 21.913L9.49698 21.836L9.86298 21.742L10.248 21.632L10.65 21.502C12.496 20.876 14.839 19.646 17.243 17.242C19.646 14.839 20.876 12.496 21.502 10.65L21.632 10.248L21.742 9.86297L21.836 9.49697L21.914 9.15097C21.9365 9.04261 21.9575 8.93393 21.977 8.82497L22.027 8.51997L22.067 8.23897L22.096 7.98097L22.116 7.74797L22.132 7.44797C22.213 5.25197 20.532 3.11897 18.588 2.28597C18.354 2.18494 18.0978 2.14647 17.8445 2.17435C17.5911 2.20222 17.3494 2.29548 17.143 2.44497ZM18.07 4.25297C19.142 4.81297 20.18 6.09297 20.133 7.37397L20.113 7.70197L20.091 7.90697L20.062 8.13697L20.022 8.38997L19.971 8.66697L19.906 8.96497L19.826 9.28497L19.73 9.62397L19.616 9.98197C19.574 10.104 19.53 10.229 19.482 10.357L19.328 10.749L19.152 11.156C18.524 12.538 17.5 14.156 15.827 15.828C14.155 17.5 12.537 18.525 11.155 19.153L10.748 19.329L10.356 19.483C10.228 19.531 10.103 19.575 9.98098 19.617L9.62298 19.731L9.28298 19.827L8.96398 19.907L8.66599 19.972L8.38898 20.023L8.13498 20.063L7.90499 20.093L7.70098 20.113L7.37298 20.133C6.10898 20.18 4.81898 19.148 4.26098 18.09C4.97298 17.255 5.85699 16.57 6.83199 15.88L7.57998 15.359L7.76999 15.558L8.17598 16.001L8.39098 16.227C8.97698 16.824 9.66098 17.331 10.481 17L10.707 16.905L10.983 16.781L11.137 16.708L11.475 16.539L11.846 16.339C12.7849 15.8165 13.6484 15.1689 14.413 14.414C15.1679 13.6494 15.8155 12.7858 16.338 11.847L16.538 11.477L16.708 11.138L16.904 10.708L17 10.48C17.311 9.71097 16.883 9.06197 16.336 8.49997L16.112 8.27997L15.555 7.76697L15.355 7.57697L15.828 6.88397C16.531 5.86397 17.218 4.94397 18.071 4.25197L18.07 4.25297ZM9.00698 6.03997L8.89098 6.05297C8.16308 6.18137 7.4945 6.53691 6.98109 7.06865C6.46768 7.60039 6.13579 8.28101 6.03299 9.01297C5.99633 9.26615 6.0581 9.52375 6.20559 9.73277C6.35308 9.9418 6.57506 10.0864 6.82588 10.1367C7.07669 10.187 7.33727 10.1393 7.55399 10.0034C7.77071 9.8675 7.9271 9.65369 7.99098 9.40597L8.01398 9.29097C8.05422 9.00407 8.17667 8.73496 8.36655 8.51616C8.55643 8.29735 8.80561 8.13821 9.08398 8.05797L9.23899 8.02297C9.49009 7.97847 9.7147 7.83971 9.86688 7.63508C10.0191 7.43045 10.0873 7.17541 10.0577 6.92212C10.0281 6.66883 9.90277 6.43643 9.70746 6.27245C9.51216 6.10848 9.26158 6.02531 9.00698 6.03997ZM8.99998 2.99997C7.40869 2.99997 5.88256 3.63211 4.75734 4.75733C3.63213 5.88255 2.99998 7.40867 2.99998 8.99997C3.00027 9.25485 3.09786 9.5 3.27283 9.68534C3.4478 9.87068 3.68694 9.98221 3.94138 9.99714C4.19582 10.0121 4.44636 9.9293 4.64182 9.76571C4.83727 9.60212 4.96288 9.37007 4.99298 9.11697L4.99998 8.99997C4.99961 7.98439 5.38575 7.00673 6.08 6.2655C6.77424 5.52426 7.72455 5.07502 8.73798 5.00897L8.99998 4.99997C9.2652 4.99997 9.51955 4.89461 9.70709 4.70708C9.89463 4.51954 9.99998 4.26519 9.99998 3.99997C9.99998 3.73475 9.89463 3.4804 9.70709 3.29286C9.51955 3.10533 9.2652 2.99997 8.99998 2.99997Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_13_2">
        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
        </clipPath>
        </defs>
      </svg>
    </a>
    <!-- <ModalForm :isAppForm="isShow" :modalClose="modalClose" />
    <ModalSuccess :modalClose="modalClose" /> -->
  </div>
</template>

<script>
import 'maz-ui/css/main.css'
import ModalForm from '@/components/Modals/Form/Tarrifs.vue'
import ModalSuccess from '@/components/Modals/Success.vue'

export default {
  data() {
    return {
      isShow: false,
    }
  },
  components: {
    ModalForm, ModalSuccess
  },
  methods: { 
    // formOpen() {
    //   this.isShow = !this.isShow
    // },
    // modalClose() {
    //   this.isShow = false
    //   document.querySelector('.main__modal.success').style.display = 'none'
    // },
  },
  }
</script>

<style scoped>
  .message-btn {
    position: fixed;
    right: 20px;
    bottom: 40px;
    width: 60px;
    height: 60px;
    background-color: #F0C62F;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center;
    -webkit-transition: background-color 0.1s linear;
    transition: background-color 0.1s linear;
    line-height: 1.875rem;
    box-shadow: rgb(38, 57, 77) 0px 20px 30px -21px;
    z-index: 99;
    cursor: pointer;
  }

  @media (max-width: 500px) {
    .message-btn {
      width: 50px;
      height: 50px;
      bottom: 30px;
    }
  }
</style>